import { MAIN_THEME } from '@styles';
import { makeStyles } from 'tss-react/mui';

interface IGridStylesProps {
  fieldsPerRow?: number;
}

export const useGridStyles = makeStyles<IGridStylesProps>()(
  (theme, { fieldsPerRow = 4 }) => ({
    fieldsGrid: {
      display: 'grid',
      gap: MAIN_THEME.size.xs,
      gridTemplateColumns: `repeat(${fieldsPerRow}, 1fr)`,
      alignItems: 'center',
    },
    fullWidthField: {
      gridColumn: '1 / -1',
      width: '100%',
    },
    submitButtonContainer: {
      width: '100%',
      display: 'flex',
      justifyContent: 'flex-end',
      alignItems: 'center',
    },
  })
);

export const useTabsLayoutStyles = makeStyles()({
  tabSplitBody: {
    display: 'flex',
    gap: MAIN_THEME.size.xs,
  },
  tabMainBody: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    gap: MAIN_THEME.size.xs,
    padding: 0,
    width: '65%',
  },
  tabRightSection: {
    display: 'flex',
    flexDirection: 'column',
    gap: MAIN_THEME.size.xs,
    padding: 0,
    width: '35%',
  },
  tabContents: {
    display: 'flex',
    flexDirection: 'column',
    gap: MAIN_THEME.size.xs,
    padding: 0,
  },
});

export const useStepperStyles = makeStyles<{
  mainContainerRatio?: number;
}>()((theme, { mainContainerRatio = 8 }) => ({
  stepperContainer: {
    display: 'flex',
    gap: MAIN_THEME.size.xs,
    margin: '30px 0',
  },
  stepperWrapper: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    gap: MAIN_THEME.size.xs,
    padding: 0,
    width: `${(mainContainerRatio / 12) * 100}%`,
  },
  actionsWrapper: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    gap: MAIN_THEME.size.xs,
    padding: 0,
    width: `${((12 - mainContainerRatio) * 100) / 12}%`,
  },
}));
